// Minimal async-state hook (no TanStack Query — keep deps small).
import { useEffect, useState, useCallback, useRef } from 'react';

export function useAsync(fn, deps = []) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const mounted = useRef(true);

  const reload = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await fn();
      if (mounted.current) setData(res);
    } catch (e) {
      if (mounted.current) setError(e);
    } finally {
      if (mounted.current) setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  useEffect(() => {
    mounted.current = true;
    reload();
    return () => {
      mounted.current = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reload]);

  return { data, error, loading, reload };
}

// Date formatting lives in format.js; re-exported so existing imports keep working.
export { formatDate, formatDateTime, relativeTime } from './format.js';

export function initials(name) {
  if (!name) return '?';
  const parts = name.trim().split(/[\s.]+/).slice(0, 2);
  return parts.map((p) => p[0]?.toUpperCase() || '').join('') || name[0].toUpperCase();
}
